import {
  REFRESH_TOKEN,
  REFRESH_TOKEN_SUCCESS,
  SET_CURRENT_USER_BUSINESSES_SUCCESS,
} from '../types/authenticate';

const initState = {
  data: {},
  isRefreshToken: false,
  userBusinesses: [],
};

const reducer = (state = initState, action) => {
  const { type } = action;
  switch (type) {
    case SET_CURRENT_USER_BUSINESSES_SUCCESS:
      return {
        ...state,
        userBusinesses: action.payload.userBusinesses || [],
        user: action.payload.user,
      };
    case REFRESH_TOKEN:
      return {
        ...state,
        isRefreshToken: true,
      };
    case REFRESH_TOKEN_SUCCESS:
      return {
        ...state,
        isRefreshToken: false,
      };
    default:
      return state;
  }
};

export default reducer;
